import {
	ModalTitleBar, ModalContent, ImageContainer, ModalMainContent, WhiteClose, ModalButtons, ModalIconSM,
	WelcomeModalContainer,
	ModalTextEntry,
	ModalBlueButton
} from "../ModalStyles";
import { useAppDispatch } from '../../../app/hooks'
import { DataState } from '../../../interfaces/enums';
import TitanTVLogo from '../../../img/TitanTV_Logo.png';
import Close from '../../../img/Icons/White Icons/TitanTV Icon_Close_White.png';
import { setModalOpen } from '../modalSlice'
import { setNewLineupStatus } from '../../UserSettingsPages/SettingsState/lineupsSlice';
import { useState } from "react";

const EnterUserId = () => {
	const dispatch = useAppDispatch();
	const [userId, setUserId] = useState('');
	const USERID_REGX_TEST = /[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}/i

	const handleClose = () => {
		dispatch(setModalOpen())
		dispatch(setNewLineupStatus(DataState.IDLE))
	}

	const handleButtonClick = () => {
		if (USERID_REGX_TEST.test(userId)) {
			localStorage.userId = userId;
			window.location.reload();
		} else {
			alert(`${userId} is not a valid ID`)
		}
	}

	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleButtonClick();
		}
	}

	return (
		<WelcomeModalContainer>
			<ModalTitleBar>
				<div></div>
				<WhiteClose onClick={() => handleClose()}>
					<ModalIconSM src={Close} alt='Close' /> Close
				</WhiteClose>
			</ModalTitleBar>
			<ModalContent>
				<ModalMainContent>
					<h2>Enter UserId, click the button and it will be loaded and the browser reloaded</h2>
					<ModalTextEntry placeholder="UserId" value={userId} onChange={(e) => setUserId(e.target.value)} onKeyDown={((e) => handleKeyDown(e))} />
				</ModalMainContent>
				<ModalButtons>
					<ModalBlueButton onClick={() => handleButtonClick()}>Load UserId</ModalBlueButton>
				</ModalButtons>
			</ModalContent>
		</WelcomeModalContainer>
	)
}

export default EnterUserId